import { isMonarchMultipleAccountsEnabled } from 'owa-accounts-store/lib/utils/flights';

export function isTodoMultiAccountAvailable(): boolean {
    return isMonarchMultipleAccountsEnabled();
}
